import GroupedDataSource from '~/Api/DataSource/GroupedDataSource';
import { DatasetPresence, PricesPresence } from '~/Api/Product';
import { findDataSources } from '~/Api/Product/SearchableDataSource';
import { findGroupedDataSources } from '~/Api/Product/SearchableDataSource/findDataSources';
import { invokeApi } from '~/ApiClient';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';
import {
	RecivedGroupedDataSroucesAction,
	RequestGroupDataSourcesAction,
	type UpdateSelectedDataSourcesAction,
} from './reducer';

export function fetchDataSources(): ThunkAction<Promise<any | null>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findDataSources));
		dispatch({ type: ActionTypes.request, request });

		try {
			const response = await request;
			dispatch({
				type: ActionTypes.receive,
				request,
				dataSources: response.items,
			});
			return response;
		} catch (error) {
			dispatch({ type: ActionTypes.receive, request, dataSources: null });
			dispatch(handleError(error));
			return null;
		}
	};
}

export function fetchGroupedDataSources(): ThunkAction<Promise<any | null>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findGroupedDataSources));
		dispatch<RequestGroupDataSourcesAction>({ type: ActionTypes.requestGrouped, request });

		try {
			const response = (await request) as unknown as { items: GroupedDataSource[] };
			dispatch<RecivedGroupedDataSroucesAction>({
				type: ActionTypes.receiveGrouped,
				request,
				groupedDataSources: response.items,
			});
			return response;
		} catch (error) {
			dispatch<RecivedGroupedDataSroucesAction>({
				type: ActionTypes.receiveGrouped,
				request,
				groupedDataSources: null,
			});
			dispatch(handleError(error));
			return null;
		}
	};
}

export function fetchDataSourcesIfNeeded(): ThunkAction<Promise<any>, any> {
	return async (dispatch, getState) => {
		getState().productSearchableDataSource.request || dispatch(fetchDataSources());
		getState().productSearchableDataSource.groupedRequest || dispatch(fetchGroupedDataSources());
	};
}

export function updatedSelectedTypes(params: {
	types: Set<string> | null;
	selectedGrouppingType: string | null;
	groupName: string | null;
	pricesPresence: PricesPresence | null;
	datasetPresence: DatasetPresence | null;
}): UpdateSelectedDataSourcesAction {
	return {
		type: ActionTypes.updatedSelectedTypes,
		selectedTypes: params.types,
		selectedGrouppingType: params.selectedGrouppingType,
		groupName: params.groupName,
		datasetPresence: params.datasetPresence,
		pricesPresence: params.pricesPresence,
	};
}
